<template>
  <div class="sm:flex mt-4 sm:mt-12 gap-2">
    <div v-html="block.content" class="w-full sm:w-1/2"
      :class="{ 'order-last sm:ml-6': block.options.image_alignment !== 'right',
                'mr-6': block.options.image_alignment == 'right', }">
    </div>
    <div class="w-full sm:w-1/2 items-center content-center object-center justify-center">
      <img :src="`${block.image}?${random_value}`" class="xshadow-lg">
    </div>

    <pre v-if="debug">
      {{ block }}
    </pre>
  </div>
</template>

<script>
export default {
  props: [ 'block' ],
  data() {
    return {
      debug: false
    }
  },
  computed: {
    random_value: () => Math.random()
  }
}
</script>